import Typeahead from "bootstrap-3-typeahead"
window.Typeahead = Typeahead;
